export default "__VITE_ASSET__828f990c__"